import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useDispatch } from 'react-redux';
import { removeActiveLayer, setOrCreateNewActiveLayer } from '../../../../redux/active_layers/Actions';

import {
    Typography,
    Collapse,
    IconButton,
    makeStyles
} from '@material-ui/core';
import { Tune as FilterIcon } from '@material-ui/icons';

import { LayerCheckbox } from './inputs';
import LayerStyles from './LayerStyles';
import LayerFiltersReduxWrapper from './LayerFiltersReduxWrapper';

const propTypes = {
    layer: PropTypes.object.isRequired,
    activeLayer: PropTypes.object
};

const defaultProps = {
    activeLayer: null
};

const useStyles = makeStyles((theme) => styles(theme));

function LayerRow ({ layer, activeLayer }) {
    const classes = useStyles();
    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        setIsExpanded(Boolean(activeLayer));
    }, [Boolean(activeLayer)]);

    const dispatch = useDispatch();
    const dispatchSetOrCreateNewActiveLayer = (layer, styling) => dispatch(setOrCreateNewActiveLayer(layer, styling));
    const dispatchRemoveActiveLayer = (uid) => dispatch(removeActiveLayer(uid));

    function toggleLayer (event) {
        if (event.target.checked) {
            dispatchSetOrCreateNewActiveLayer({
                uid: layer.system_name,
                systemName: layer.system_name,
                visible: true,
                printable: true
            }, layer);
        } else {
            dispatchRemoveActiveLayer(layer.system_name);
        }
    }

    const filters = layer.filterConfig && layer.filterConfig.fields;
    const hasFilters = filters && Object.keys(filters).some(field => !filters[field].tags || filters[field].tags.includes('tile'));

    return (
        <>
            <div className={classes.layerItemSettings}>
                <LayerCheckbox
                    color="primary"
                    checked={activeLayer ? activeLayer.visible : false}
                    onChange={toggleLayer}
                />
                <Typography
                    variant="body2"
                    color="textPrimary"
                    classes={{root: classes.layerItemTitleText}}
                >
                    { layer.name }
                </Typography>
                {
                    layer.styles && layer.styles.length > 1 && <LayerStyles layer={layer} />
                }
                { hasFilters &&
                    <IconButton
                        className={classnames(classes.filterButton, isExpanded && classes.filterButtonActive)}
                        onClick={() => { setIsExpanded(!isExpanded); }}
                    >
                        <FilterIcon />
                    </IconButton>
                }
            </div>
            { hasFilters &&
                <Collapse
                    in={isExpanded}
                >
                    <div className={classes.filters}>
                        <LayerFiltersReduxWrapper systemName={layer.system_name} />
                    </div>
                </Collapse>
            }
        </>
    );
}

const styles = theme => ({
    filterButton: {
        color: theme.palette.grey.variant3,
        padding: 0,
        marginRight: theme.constants.horizontalMargin
    },
    filterButtonActive: {
        color: theme.palette.text.primary
    },

    layerItemSettings: {
        display: 'flex',
        alignItems: 'center',
        padding: '6px 12px'
    },
    layerItemCheckbox: {
        display: 'flex',
        alignItems: 'center',
        gridColumnGap: theme.spacing(2)
    },
    layerItemTitleText: {
        marginLeft: 12,
        marginRight: 'auto'
    },
    filters: {
        padding: '0px 44px' // checkbox (20) + paddingx2 (12*2)
    },
    filterIcon: {
        cursor: 'pointer',
        '& > path': {
            fill: theme.palette.grey.variant3
        }
    },
    filterIconSelected: {
        '& > path': {
            fill: theme.palette.background.contrastText
        }
    }
});

LayerRow.propTypes = propTypes;
LayerRow.defaultProps = defaultProps;

export default LayerRow;